// SubscriptionStatus is an object representing the status of a subscription
const SubscriptionStatus = {
  Created: "created",
  Paid: "paid",
  Expired: "expired",
};

Object.freeze(SubscriptionStatus);

export default SubscriptionStatus;
